import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {fromLonLat} from 'ol/proj';
import Overlay from 'ol/Overlay.js';

const queryString = window.location.search;
console.log(queryString);
const urlParams = new URLSearchParams(queryString);
let lat = 51.48;
let lon = 7.22;
let zoom = 10;
if (urlParams.has('lat')) {
  lat = urlParams.get('lat');
} 

if (urlParams.has('lon')) {
  lon = urlParams.get('lon');
} 

if (urlParams.has('lat') && urlParams.has('lon')) {
  zoom = 16;
}


/**
 * Elements that make up the popup.
 */
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');

/**
 * Create an overlay to anchor the popup to the map.
 */
const overlay = new Overlay({
  element: container,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
});

/**
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */
closer.onclick = function () {
  overlay.setPosition(undefined);
  closer.blur();
  selectInteraction.getFeatures().clear();
  return false;
};


const map = new Map({
  overlays: [overlay],
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    center: fromLonLat([lon, lat]),
    zoom: zoom
  })
});

//Fetch points data from the database
const pointData = await fetch('../get_places.php')
 .then(response => response.json());


    // TestArray
  //   var pointData = [
  //     { latitude: 51.48, longitude: 7.22, name: 'Marker 1', log_date: '2023-01-15' },
  //     { latitude: 51.49, longitude: 7.22, name: 'Marker 2', log_date: '2023-01-15'},
  //     { latitude: 51.47, longitude: 7.22, name: 'Marker 3', log_date: '2023-01-15' }
  // ];

// Import vector layer and source to add points from a database
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
//import {Style, Icon} from 'ol/style';
import {Style, Stroke, Circle, Fill} from 'ol/style';

// Create a new vector source and add the point data as features
const vectorSource = new VectorSource({
  features: pointData.map(point => {
    const feature = new Feature({
      geometry: new Point(fromLonLat([point.longitude, point.latitude]))
    });
    // Add a name property to the feature for display
    feature.setProperties({ name: point.name, log_date: point.log_date });
    return feature;
  })
});

// Create a new vector layer using the vector source and a circle
const vectorLayer = new VectorLayer({
  source: vectorSource,
  style: new Style({
    image: new Circle({
      radius: 8,
      fill: new Fill({color: 'red'}),
      stroke: new Stroke({color: 'white', width: 2})
    })
  })
});

// Add the vector layer to the map
map.addLayer(vectorLayer);


// Select interaction to handle click events on features
import Select from 'ol/interaction/Select';
const selectInteraction = new Select();
map.addInteraction(selectInteraction);


// Add a function to display the feature name on click
selectInteraction.on('select', e => {
  const feature = e.selected[0];
  if (feature) {
    const name = feature.getProperties().name;
    const log_date = feature.getProperties().log_date;
    const overlayhtml = '<p>'+name+'</p><p>'+ log_date +'</p>';
    overlay.setPosition(feature.getGeometry().getCoordinates());
    document.getElementById('popup-content').innerHTML = overlayhtml;
    overlay.setPositioning('bottom-center');
    overlay.setOffset([0, -10]);
    overlay.setVisible(true);
  } 
});
